import React from 'react';

// Component for individual card
function Card({ bgClass, textColorClass, title, description, category, img }) {
  return (
    <div className={`bg-white rounded-lg shadow-md overflow-hidden`}>
      <img
        src={`/images/${img}`}
        alt={title}
        width={500}
        className="w-full"
      />
      <div className="p-6 mt-0">
        {/* <div className={`inline-block rounded-lg ${bgClass} px-3 py-1 mb-3 text-sm ${textColorClass}`}>
          {category}
        </div> */}
        <h3 className="text-xl">{title}</h3>
        <p className="text-gray-500 mb-0">
          {description}
        </p>
      </div>
    </div>
  );
}

export function CustomCard1() {
  const cardData1 = [
    {
      bgClass: 'bg-slate-800',
      textColorClass: 'text-slate-100',
      // category: 'Networking',
      title: 'Our Venue',
      description: 'ICC Sydney is a world class Convention Centre located in Darling Harbour and has easy access to a wide range of accommodation, transport and restaurants.',
      img: 'home-box-1.webp',
    },
    {
      bgClass: 'bg-slate-800',
      textColorClass: 'text-slate-100',
      // category: 'Leadership',
      title: 'Connect globally ',
      description: '5WCWS is the world’s largest Conference by and for women’s shelters, and those working to end gender-based violence. This is an unparalleled opportunity to meet and connect with your global colleagues.',
      img: 'home-box-2.webp',
    },
    {
      bgClass: 'bg-slate-800',
      textColorClass: 'text-slate-100',
      // category: 'Best practices',
      title: 'High profile keynotes',
      description: 'Prominent figures such as Queen Mary of Denmark, Queen Maxima of the Netherlands, Reese Witherspoon, Former U.S. President Bill Clinton, and Denis Mukwege have supported the shelter movement, advocating for social change to end violence and oppression against women and children.',
      img: 'home-box-3.webp',
    },
    {
      bgClass: 'bg-slate-800',
      textColorClass: 'text-slate-100',
      // category: 'Global movement',
      title: 'Learn and share',
      description: '5WCWS will offer so many formats to share and learn together such as Study tours, Interactive Workshops and demonstrations, as well as lived experience advocates.',
      img: 'home-box-4.webp',
    },
  ];

  return (
    <>
      {cardData1.map((card, index) => (
        <Card key={index} {...card} />
      ))}
    </>
  );
}

// Component for individual profile card
function ProfileCard({ name, company, bio, avatar }) {
  return (
    <div className="bg-gray-800 rounded-lg shadow-md p-6 space-y-4">
      {/* <div className="flex items-center space-x-4">
        <img src={avatar} width={48} height={48} alt="Avatar" className="rounded-full object-cover h-[48px]" />
        <div>
          <h4 className="text-lg mb-0 font-bold text-white">{name}</h4>
          <p className="text-gray-400 mb-0">{company}</p>
        </div>
      </div> */}
      <blockquote className="text-gray-300 italic">
        {bio}
      </blockquote>
    </div>
  );
}

export function CustomCard2() {
  const cardData2 = [
    {
      name: 'Jane Doe',
      company: 'CEO, Acme Inc.',
      bio: 'The conference was very empowering.  Thank you to all the members who support it.',
      avatar: '/images/color-book.jpg',
    },
    {
      name: 'John Smith',
      company: 'CTO, Acme Inc.',
      bio: 'I enjoyed meeting women from all over the world who worked in the same sector and faced some similar challenges. After the conference, I had so many ideas that I am now implementing at my centre.',
      avatar: '/images/color-book.jpg',
    },
    {
      name: 'Sarah Johnson',
      company: 'Lead Developer, Acme Inc.',
      bio: 'It was so powerful and the presentations were from people who have incredible stories to tell, challenges highlighted well and way forward discussed.',
      avatar: '/images/color-book.jpg',
    },
  ];

  return (
    <>
      {cardData2.map((profile, index) => (
        <ProfileCard key={index} {...profile} />
      ))}
    </>
  );
}


export function ContactCard() {
  return (
    <div className="bg-gray-800 rounded-lg shadow-md p-6 space-y-4">
      <h4 className="text-lg font-bold text-white">Contact Us</h4>
      <p className="text-gray-400">Get in touch with us using the form below.</p>
    </div>
  );
}